<style lang="scss" scoped>
div.spinner {
  position: absolute;
  z-index: 1;
  width: 96%;
  height: 70%;
  background-color: rgba(0, 0, 0, 0.5);
}

i.spinner {
  top: 40%;
  position: fixed;
  left: 55%;
}
</style>

<template>
  <div>
    <chart-card
      v-if="!loading"
      :chart-data="revenueChart"
      :chart-options="revenueChart.options"
      chart-type="Line"
      :chart-height="175"
    >
      <template slot="header">
        <h4 class="card-title">Umgebungsdaten</h4>
      </template>
      <template slot="footer">
        <div></div>
      </template>
      <template slot="filter-content">
        <table-filter
          :filterComponents="[
            {
              type: 'DateTimeRangeFilter',
              name: 'date'
            }
          ]"
          v-model="filter"
          @apply-filters="$bus.$emit('refresh-table')"
          :autoApply="true"
        ></table-filter>
      </template>
      <template slot="footer">
        <hr />
        <div class="stats">
          <i class="fa fa-history"></i> Letzte {{ minutesToShow }} Minuten
        </div>
      </template>
    </chart-card>
    <div v-if="loading" class="spinner">
      <i class="fas fa-sync fa-7x fa-spin spinner"></i>
    </div>
  </div>
</template>

<script>
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import { brightenHex } from "src/components/UIComponents/Charts/utils";

import moment from "moment";

export default {
  components: {
    ChartCard
  },
  data() {
    return {
      diffType: "minute",
      loading: true,
      dates: [],
      minutesToShow: 30,
      revenueChart: {
        labels: [],
        datasets: [],
        options: {
          scales: {
            yAxes: [
              {
                id: "A",
                type: "linear",
                position: "left"
              }
            ]
          },
          legend: {
            display: true
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                return (
                  data.datasets[tooltipItem.datasetIndex].label +
                  ": " +
                  tooltipItem.value
                );
              }
            }
          }
        }
      },
      filter: [
        {
          name: "whereDate",
          attributes: [
            {
              column: "since",
              operator: "<=",
              value: moment()
                .subtract(30, "minute")
                .format("YYYY-MM-DD HH:mm")
            },
            {
              column: "to",
              operator: ">=",
              value: moment().format("YYYY-MM-DD HH:mm")
            }
          ]
        }
      ]
    };
  },
  methods: {
    setupDays() {
      let difference = 0;
      let diff = moment.duration(
        moment(this.filter[0].attributes[1].value).diff(
          moment(this.filter[0].attributes[0].value)
        )
      );
      this.diffType = "minute";
      difference = Math.abs(diff.asMinutes());
      if (difference > 60) {
        this.diffType = "hour";
        difference = Math.abs(diff.asHours());
      }
      if (difference > 72) {
        this.diffType = "day";
        difference = Math.abs(diff.asDays());
      }

      this.dates = [];
      for (let i = 0; i < difference + 1; i++) {
        let date = new Date(this.filter[0].attributes[0].value);
        if (this.diffType == "day") {
          date.setDate(date.getDate() + i);
        } else if (this.diffType == "hour") {
          date.setHours(date.getHours() + i);
        } else {
          date.setMinutes(date.getMinutes() + i);
        }
        this.dates.push(date);
      }
    },
    setupDayLabels() {
      let dayLabels = this.dates.map(date => {
        date = moment(date);

        return date.format("DD.MM.YYYY HH:mm");
      });

      this.revenueChart.labels = dayLabels;
    },

    setupDatasets() {
      if (
        this.$store.getters["user/meHasPermissionTo"]("access_super_admin_area")
      ) {
        this.revenueChart.options.scales.yAxes.push({
          id: "B",
          type: "linear",
          position: "right"
        });
      }
      this.loading = true;
      this.$http
        .get("/api/v1/statistic/allStatistic", {
          params: {
            filter: this.filter,
            diffType: this.diffType
          }
        })
        .then(({ data }) => {
          let datasets = [];
          let currentDataset = [];
          Object.keys(data).forEach(type => {
            let hash = 0;
            for (let i = 0; i < type.length; i++) {
              hash = type.charCodeAt(i) + ((hash << 5) - hash);
            }
            let c = (hash & 0x00ffffff).toString(16).toUpperCase();
            let color = "00000".substring(0, 6 - c.length) + c;
            let hoverColor = brightenHex(color, 15);
            let yAxis = "A";
            if (type == "Cpu" || type == "Ram") {
              yAxis = "B";
            }
            currentDataset = {
              label: type,
              yAxisID: yAxis,
              borderColor: "#" + color,
              fill: false,
              backgroundColor: "#" + color,
              hoverBorderColor: hoverColor,
              hoverBackgroundColor: hoverColor,
              borderWidth: 5,
              data: []
            };
            this.dates.forEach(date => {
              let time = date.getTime() / 1000;
              if (data[type][time]) {
                currentDataset.data.push(data[type][time]);
              } else {
                currentDataset.data.push(0);
              }
            });
            datasets.push(currentDataset);
          });
          this.revenueChart.datasets = datasets;
          this.loading = false;
        });
    }
  },
  created() {
    this.setupDays();
    this.setupDayLabels();
    this.setupDatasets();
  },
  watch: {
    filter() {
      this.setupDays();
      this.setupDayLabels();
      this.setupDatasets();
    }
  }
};
</script>
